
















import Vue from 'vue';
import Component from 'vue-class-component';
import TicketMessage from './TicketMessage.vue';
import extractUserFromTicketReply from '../helpers/extractUserFromTicketReply';

const TicketReplyProps = Vue.extend({
  props: {
    reply: {
      type: Object,
      required: true,
    },
  },
});

@Component({
  name: 'TicketReply',

  components: {
    TicketMessage,
  },
})
export default class TicketReply extends TicketReplyProps {
  get userInfo() {
    return extractUserFromTicketReply(this.reply);
  }
}
